<template>
  <div class="hotel-card" :class="{ 'active': isActive, 'urgent': hotel.walletBalance > 0 }" @click="$emit('click')">
    <div class="card-top">
      <span class="hotel-name" :title="hotel.HotelNameCn">{{ hotel.HotelNameCn }}</span>
      <span class="star-badge">{{ hotel.Star }}⭐</span>
    </div>
    <div class="card-middle">
      <div class="price-box">
        <span class="currency">¥</span><span class="amount">{{ hotel.minPrice }}</span><span class="unit">起</span>
      </div>
      <div class="info-tags">
        <el-tag v-if="hotel.IsGuarantee" type="primary" size="mini" effect="dark" style="margin-right: 4px;">全款</el-tag>
        <el-tag v-if="hotel.walletBalance > 0" type="danger" size="mini" effect="dark">定金 ¥{{ (hotel.walletBalance/10000).toFixed(1) }}万</el-tag>
        <el-tag v-if="hotel.hasBus" type="success" size="mini" effect="plain" style="margin-left: 4px;">班车</el-tag>
        <el-tag v-if="hotel.isMain" color="#ffd700" style="color:#333; border:none; margin-left: 4px;" size="mini">主推</el-tag>
      </div>
    </div>
    <div class="card-bottom">
      <span class="distance" v-if="hotel.distance">
        <i class="el-icon-location-outline"></i> 距 {{hotel.targetHallName}} {{ (hotel.distance / 1000).toFixed(1) }} km
      </span>
      <span class="distance" v-else><i class="el-icon-map-location"></i> 坐标计算中</span>
      <span class="stock" :class="{'out': hotel.totalAvailable === 0}">
        {{ hotel.totalAvailable > 0 ? `余 ${hotel.totalAvailable} 间` : '已满房' }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HotelCard',
  props: ['hotel', 'isActive']
}
</script>

<style scoped lang="scss">
/* 引入 SCSS 确保子组件卡片样式正确 */
@use "@/assets/styles/dashboard/sidebar.scss";
</style>